"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const access_1 = require("@completeanatomy/access");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const hooks_1 = require("../../hooks");
const SystemMenuButton_1 = __importDefault(require("../../molecules/SystemMenuButton"));
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const withBridgeProvider_1 = __importDefault(require("../../hocs/withBridgeProvider"));
const selectors_1 = require("../../store/selectors");
const SystemStatus_1 = __importDefault(require("../SystemStatus"));
// eslint-disable-next-line max-lines-per-function
function SystemsMenu() {
    const [openedControls, setOpenedControls] = (0, react_1.useState)(null);
    const [systemStatus, setSystemStatus] = (0, react_1.useState)(null);
    const [defaultSubTitleStatus, setDefaultSubTitleStatus] = (0, react_1.useState)(null);
    const bridge = (0, bridge_1.useBridge)();
    const [isOpenAccessModal, setIsOpenAccessModal] = (0, react_1.useState)(false);
    const systems = (0, hooks_1.useSelector)(selectors_1.getSystemStates);
    const containerRef = (0, react_1.useRef)(null);
    const systemStatusTimer = (0, react_1.useRef)(0);
    const onToggleButtonsControls = (systemId) => {
        const value = openedControls === systemId ? null : systemId;
        if (value !== null) {
            clearTimeout(systemStatusTimer.current);
        }
        showSystemStatus(value);
        setOpenedControls(value);
    };
    const showSystemStatus = (systemId) => {
        setSystemStatus(systemId);
    };
    /**
     * Hack to support shortcuts, @todo remove this once we have a proper solution in modules
     */
    (0, react_1.useEffect)(() => {
        var _a;
        const onShortcut = (action) => (notification) => {
            const identifier = notification.userInfo.identifier;
            const system = systems.find(s => s.identifier === identifier);
            if (system === null || system === void 0 ? void 0 : system.isDisabled) {
                return;
            }
            onEvent(identifier, action);
        };
        const onAddLayerShortcut = onShortcut(bridge_schema_1.SystemsMenuAction.Plus);
        const onRemoveLayerShortcut = onShortcut(bridge_schema_1.SystemsMenuAction.Minus);
        const onSwitchOnOffShortcut = onShortcut(bridge_schema_1.SystemsMenuAction.Simple);
        const onHide = () => {
            onToggleButtonsControls(null);
        };
        // @ts-ignore
        if ((_a = window.Utils) === null || _a === void 0 ? void 0 : _a.EventEmitter) {
            // @ts-ignore
            window.Utils.EventEmitter.on('WOLShortcutAddSystemLayerNotification', onAddLayerShortcut);
            // @ts-ignore
            window.Utils.EventEmitter.on('WOLShortcutRemoveSystemLayerNotification', onRemoveLayerShortcut);
            // @ts-ignore
            window.Utils.EventEmitter.on('WOLShortcutSwitchOnOffSystemNotification', onSwitchOnOffShortcut);
            // @ts-ignore
            window.Utils.EventEmitter.on([
                'WOLMouseDownEventNotification',
                'WOLUIHelpViewWillShowNotification',
                'WOLUIBodyRegionViewWillShowNotification',
                'WOLModelManipulationDidStartNotification',
                'WOLUIToolkitPanelWillSelectToolNotification',
                'WOLUICentralAreaFooterWillDisappearNotification',
                'MainMenuContentTypeDidChangeNotification',
            ], onHide);
        }
        return () => {
            var _a;
            // @ts-ignore
            if ((_a = window.Utils) === null || _a === void 0 ? void 0 : _a.EventEmitter) {
                // @ts-ignore
                window.Utils.EventEmitter.off('WOLShortcutAddSystemLayerNotification', onAddLayerShortcut);
                // @ts-ignore
                window.Utils.EventEmitter.off('WOLShortcutRemoveSystemLayerNotification', onRemoveLayerShortcut);
                // @ts-ignore
                window.Utils.EventEmitter.off('WOLShortcutSwitchOnOffSystemNotification', onSwitchOnOffShortcut);
                // @ts-ignore
                window.Utils.EventEmitter.off([
                    'WOLMouseDownEventNotification',
                    'WOLUIHelpViewWillShowNotification',
                    'WOLUIBodyRegionViewWillShowNotification',
                    'WOLModelManipulationDidStartNotification',
                    'WOLUIToolkitPanelWillSelectToolNotification',
                    'WOLUICentralAreaFooterWillDisappearNotification',
                    'MainMenuContentTypeDidChangeNotification',
                ], onHide);
            }
        };
    });
    const onClickOutside = () => {
        onToggleButtonsControls(null);
    };
    (0, ui_1.useOutsideClick)(containerRef, onClickOutside);
    const onEvent = (0, react_1.useCallback)((identifier, type) => {
        switch (type) {
            case bridge_schema_1.SystemsMenuAction.Plus:
            case bridge_schema_1.SystemsMenuAction.LongPlus:
                setDefaultSubTitleStatus(null);
                break;
            case bridge_schema_1.SystemsMenuAction.Minus:
            case bridge_schema_1.SystemsMenuAction.LongMinus:
                setDefaultSubTitleStatus(null);
                break;
            case bridge_schema_1.SystemsMenuAction.Simple:
                const system = systems.find(s => s.identifier === identifier);
                setDefaultSubTitleStatus((system === null || system === void 0 ? void 0 : system.subtitle) || null);
                break;
        }
        switch (type) {
            case bridge_schema_1.SystemsMenuAction.LongPlus:
            case bridge_schema_1.SystemsMenuAction.Simple:
            case bridge_schema_1.SystemsMenuAction.LongMinus:
                showSystemStatus(identifier);
                if (!openedControls) {
                    clearTimeout(systemStatusTimer.current);
                    systemStatusTimer.current = window.setTimeout(() => {
                        setSystemStatus(null);
                        setDefaultSubTitleStatus(null);
                    }, 1000);
                }
        }
        bridge === null || bridge === void 0 ? void 0 : bridge.changeSystemState({ identifier, mode: type });
    }, [bridge, openedControls, systems]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(access_1.AccessPopup, { isOpen: isOpenAccessModal, onClose: () => setIsOpenAccessModal(false), "data-e2e": 'SystemsMenu_AccessPopup' }), (0, jsx_runtime_1.jsx)(SystemStatus_1.default, { openedSystemId: systemStatus, defaultSubTitleStatus: defaultSubTitleStatus, "data-e2e": 'SystemsMenu_SystemStatus' }), (0, jsx_runtime_1.jsx)(Container, { "$controlsOpened": openedControls !== null, ref: containerRef, "data-e2e": 'SystemsMenu_Container', children: systems.map(system => ((0, jsx_runtime_1.jsx)(SystemMenuButton_1.default, Object.assign({}, system, { onEvent: onEvent, onToggleControls: onToggleButtonsControls, openedControls: openedControls, onOpenAccessPopup: () => setIsOpenAccessModal(true), isDisabled: system.isDisabled, "data-e2e": 'SystemsMenu_SystemsMenuButton' }), system.identifier))) })] }));
}
exports.default = (0, device_1.withPlatformProvider)((0, withBridgeProvider_1.default)(SystemsMenu));
const Container = styled_components_1.default.div `
  display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
  flex-grow: 1;
  justify-content: flex-start;
  height: 100%;
  margin-right: 15px;

  overflow-x: ${({ $controlsOpened }) => ($controlsOpened ? 'hidden' : 'auto')};

  &::-webkit-scrollbar {
    display: none;
  }

  padding-bottom: 10px;
  margin-top: 0px;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    max-width: 1366px;

    overflow-x: auto;
    overflow-y: hidden;
    margin-top: 8px;
  `)};

  ${ui_1.device.laptop((0, styled_components_1.css) `
    margin-top: 10px;
  `)}

  ${ui_1.deviceLandscape.mobileS((0, styled_components_1.css) `
    padding-bottom: 10px;
    margin-top: 0;
  `)}

  ${ui_1.deviceLandscape.mobileM((0, styled_components_1.css) `
    margin-top: 0;
  `)};

  ${ui_1.deviceLandscape.tablet((0, styled_components_1.css) `
    justify-content: space-around;
    margin-right: auto;
    margin-left: auto;
    margin-top: 0;
  `)};

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    padding-bottom: 10px;
    margin-top: 8px;
  `)};

  ${ui_1.deviceLandscape.laptopL((0, styled_components_1.css) `
    padding-bottom: 0px;
  `)};
`;
